module.exports = __webpack_public_path__ + "static/media/nav-icon3.81ff4e97.svg";